import {
  formatInvitationCodeInput,
  isInvitationCodeComplete,
} from '@/features/auth/utils/invitationCodeFormat.js'

export const INVITATION_CODE_QUERY_KEYS = ['invitationCode', 'code']

export const INVITATION_OPEN_MODAL_QUERY_KEY = 'openInvitation'

function getFirstQueryValue(value) {
  if (Array.isArray(value)) {
    return value[0]
  }

  return value
}

export function getInvitationCodeFromQuery(query = {}) {
  for (const key of INVITATION_CODE_QUERY_KEYS) {
    const rawValue = getFirstQueryValue(query[key])

    if (typeof rawValue === 'string' && rawValue.trim()) {
      return formatInvitationCodeInput(rawValue)
    }
  }

  return ''
}

export function getEmailFromQuery(query = {}) {
  const rawValue = getFirstQueryValue(query.email)

  if (typeof rawValue === 'string' && rawValue.trim()) {
    return rawValue.trim()
  }

  return ''
}

export function isInvitedRegistrationQuery(query = {}) {
  return isInvitationCodeComplete(getInvitationCodeFromQuery(query))
}

export function shouldOpenInvitationModalFromQuery(query = {}) {
  const openInvitation = getFirstQueryValue(query[INVITATION_OPEN_MODAL_QUERY_KEY])

  return openInvitation === '1' || openInvitation === 'true'
}

export function pickInvitationQueryForRoute(query = {}) {
  const invitationCode = getInvitationCodeFromQuery(query)
  const email = getEmailFromQuery(query)
  const activeClubId = getFirstQueryValue(query.activeClubId)
  const redirectUrl = getFirstQueryValue(query.redirectUrl)

  const picked = {}

  if (invitationCode) {
    picked.invitationCode = invitationCode
  }

  if (email) {
    picked.email = email
  }

  if (activeClubId) {
    picked.activeClubId = activeClubId
  }

  if (redirectUrl) {
    picked.redirectUrl = redirectUrl
  }

  return picked
}

export function omitInvitationFromRouteQuery(query = {}) {
  const nextQuery = { ...query }

  for (const key of INVITATION_CODE_QUERY_KEYS) {
    delete nextQuery[key]
  }

  delete nextQuery[INVITATION_OPEN_MODAL_QUERY_KEY]

  return nextQuery
}

export function buildRegisterRouteQuery({ invitationCode, activeClubId, email, redirectUrl } = {}) {
  return pickInvitationQueryForRoute({
    invitationCode,
    activeClubId,
    email,
    redirectUrl,
  })
}

export function buildLoginRouteQuery({
  invitationCode,
  activeClubId,
  email,
  redirectUrl,
  openInvitation = false,
} = {}) {
  const query = buildRegisterRouteQuery({
    invitationCode,
    activeClubId,
    email,
    redirectUrl,
  })

  if (openInvitation) {
    query[INVITATION_OPEN_MODAL_QUERY_KEY] = '1'
  }

  return query
}
